import './conversation_attribute_view.js.coffee'

class Customer.FixedStringAttributeView extends Customer.ConversationAttributeView
  template: JST['backbone/templates/customer/custom_attributes/fixed_string']
  titleClassName: 'fixed_string'

  render: ->
    super()
    @tagsView = @selectView()
    @listenTo(@tagsView, 'change', () => @trigger('conversation:attributes:edit'))
    @$el.find('#tags').append(@tagsView.el)
    @listenTo @tagsView, 'change', @onUpdate
    @onUpdate()
    @_renderError()
    @

  selectedOptions: ->
    tag.id for tag in @model.get('definition').get('tags') when tag.name in @initialValues()

  selectView: ->
    if @model.get('definition').get('multiple')
      view = App.SelectView
    else
      view = App.UniqueSelectView
    new view
      selectedOptions: @selectedOptions()
      options: _.sortBy(@model.get('definition').get('tags'), (tag) -> tag.order)
      valueProperty: 'id'
      descriptionProperty: 'name'
      placeholder: I18n.t('user_profiles.custom_attributes.add_tag')
      width: '100%'

  onUpdate: ->
    return if @model.get('definition').get('multiple')
    shouldDisable = @tagsView.toDescriptionArray().length >= 1
    @$el.find('select').prop('disabled', shouldDisable)
    @$el.find('select').trigger('chosen:updated')

  getAdded: ->
    values = _.filter(
      _.difference(@tagsView.toDescriptionArray(), @initialValues()),
      (value) -> value
    )
    return null if _.isEmpty(values)
    definition_code: @getDefinitionCode(),
    values: values

  getDeleted: ->
    values = _.filter(
      _.difference(@initialValues(), @tagsView.toDescriptionArray()),
      (value) -> value
    )
    return null if _.isEmpty(values)
    definition_code: @getDefinitionCode(),
    values: values

  validValue: ->
    true

  _renderError: ->
    errors = @model.getErrors()
    @_renderSelectRedBorder() if @model.error || (errors && errors.length)

  _renderSelectRedBorder: () =>
    @$el.find('.fixed-string-container').addClass('error')
